import { Outlet, useNavigate } from "react-router-dom";
import { GlassWater, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useUserProfile } from "@/hooks/useUserProfile";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function ClientBottlingLayout() {
  const { user, signOut } = useAuth();
  const { data: profile } = useUserProfile();
  const navigate = useNavigate();

  const initials = user?.email
    ? user.email.substring(0, 2).toUpperCase()
    : "U";

  return (
    <div className="flex flex-col h-screen w-full bg-background">
      {/* Top bar */}
      <header className="flex items-center justify-between border-b px-6 py-3">
        <div className="flex items-center gap-2.5">
          <div className="flex items-center justify-center rounded-md bg-rose-100 p-1.5 text-rose-600 dark:bg-rose-500/20 dark:text-rose-400">
            <GlassWater className="h-4 w-4" />
          </div>
          <span className="text-[15px] font-semibold tracking-tight">Bottling Scheduler</span>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="gap-2 px-2">
              <Avatar className="h-7 w-7">
                <AvatarImage src={profile?.avatar_url || ""} />
                <AvatarFallback className="text-xs">{initials}</AvatarFallback>
              </Avatar>
              <span className="text-sm hidden sm:inline">
                {profile?.display_name || user?.email?.split("@")[0] || "User"}
              </span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => signOut()} className="text-destructive focus:text-destructive">
              <LogOut className="h-4 w-4 mr-2" />
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </header>

      {/* Content */}
      <main className="flex-1 min-h-0 overflow-y-auto" style={{ backgroundImage: 'var(--bg-stripe-pattern)' }}>
        <Outlet />
      </main>
    </div>
  );
}
